import { render, staticRenderFns } from "./Office-New-Request-Step3.vue?vue&type=template&id=2bcaf4ae&scoped=true&"
import script from "./Office-New-Request-Step3.vue?vue&type=script&lang=js&"
export * from "./Office-New-Request-Step3.vue?vue&type=script&lang=js&"
import style0 from "./Office-New-Request-Step3.vue?vue&type=style&index=0&id=2bcaf4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcaf4ae",
  null
  
)

export default component.exports